export default "__VITE_PUBLIC_ASSET__7a2324e0__"